import { render, staticRenderFns } from "./draftsDetail.vue?vue&type=template&id=c8fd2f80&scoped=true&"
import script from "./draftsDetail.vue?vue&type=script&lang=js&"
export * from "./draftsDetail.vue?vue&type=script&lang=js&"
import style0 from "./draftsDetail.vue?vue&type=style&index=0&id=c8fd2f80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fd2f80",
  null
  
)

export default component.exports